<p-dialog *ngIf="customMenuSelected" [(visible)]="customMenuSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'fork-knife']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">Custom Menu</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'bars']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Menu Setup</div>
			</ng-template>
			<div class="p-grid">
				<div class="p-col-12 p-md-6">
					<span class="p-float-label mt-4">
						<input pInputText #customMenuNameInput name="customMenuNameInput" type="text" [(ngModel)]="customMenuSelected.name" class="w-100" />
						<label for="customMenuNameInput">Menu Name</label>
					</span>
					<div class="d-flex mt-2">
						<div class="display-14 my-auto">Default menu</div>
						<div class="ms-2">
							<p-inputSwitch [(ngModel)]="customMenuSelected.active"></p-inputSwitch>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-6">
					<p-listbox
						[options]="assignableCanvases"
						optionLabel="name"
						optionDisabled="!online"
						[checkbox]="true"
						[filter]="true"
						[multiple]="true"
						[listStyle]="{ 'max-height': '300px' }"
						[(ngModel)]="assignedCanvases"
						[disabled]="venueService.subscriptionOOcanvas.value.length === 0"
					></p-listbox>
				</div>
			</div>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'link']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">External Links</div>
			</ng-template>
			<app-oo-menu-external-link [(externalLinks)]="customMenuSelected.externalLinks"></app-oo-menu-external-link>
		</p-tabPanel>
	</p-tabView>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]=""
			[hideSave]=""
			(onCancelChange)="assignableCanvases = undefined; assignedCanvases = undefined; customMenuSelected = undefined"
			(onDeleteChange)="customMenuDelete(customMenuSelected.key)"
			(onSaveChange)="customMenuAssignSave()"
			[cancelDisabled]=""
			[deleteDisabled]="customMenuSelected.unsaved"
			[saveDisabled]="!customMenuSelected.name"
			[deletePromptOverride]="true"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
